<template>
  <el-dialog
    title="修改系统配置"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="editSystemInfoInfo" label-width="120px">
      <el-form-item label="标题名称" prop="systemTitle">
        <el-input
          v-model="editSystemInfoInfo.systemTitle"
          placeholder="必填，请填写标题名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="副标题" prop="subSystemTitle">
        <el-input
          v-model="editSystemInfoInfo.subSystemTitle"
          placeholder="必填，请填写副标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="简写标题" prop="systemSimpleTitle">
        <el-input
          v-model="editSystemInfoInfo.systemSimpleTitle"
          placeholder="必填，请填写简写标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="公司名称" prop="companyName">
        <el-input
          v-model="editSystemInfoInfo.companyName"
          placeholder="必填，请填写公司名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="logo地址" prop="logoUrl">
        <el-input
          v-model="editSystemInfoInfo.logoUrl"
          placeholder="必填，请填写logo地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="静态url" prop="imgUrl">
        <el-input
          v-model="editSystemInfoInfo.imgUrl"
          placeholder="必填，请填写静态url"
        ></el-input>
      </el-form-item>
      <el-form-item label="默认小区编号" prop="defaultCommunityId">
        <el-input
          v-model="editSystemInfoInfo.defaultCommunityId"
          placeholder="必填，请填写默认小区编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="业主标题" prop="ownerTitle">
        <el-input
          v-model="editSystemInfoInfo.ownerTitle"
          placeholder="必填，请填写业主标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="物业手机标题" prop="propertyTitle">
        <el-input
          v-model="editSystemInfoInfo.propertyTitle"
          placeholder="必填，请填写物业手机标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="qq地图key" prop="qqMapKey">
        <el-input
          v-model="editSystemInfoInfo.qqMapKey"
          placeholder="必填，请填写qq地图key"
        ></el-input>
      </el-form-item>
      <el-form-item label="商城地址" prop="mallUrl">
        <el-input
          v-model="editSystemInfoInfo.mallUrl"
          placeholder="必填，请填写商城地址"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="editSystemInfo">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateSystemInfo } from '@/api/frame/systemInfoApi'

export default {
  name: 'EditSystemInfo',
  data() {
    return {
      dialogVisible: false,
      editSystemInfoInfo: {
        systemId: '',
        systemTitle: '',
        subSystemTitle: '',
        companyName: '',
        logoUrl: '',
        imgUrl: '',
        defaultCommunityId: '',
        ownerTitle: '',
        propertyTitle: '',
        qqMapKey: '',
        mallUrl: '',
        systemSimpleTitle: ''
      }
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true
      if (data) {
        this.editSystemInfoInfo = { ...data }
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    editSystemInfo() {
      if (!this.validateForm()) {
        return
      }
      updateSystemInfo(this.editSystemInfoInfo)
        .then(res => {
          if (res.code === 0) {
            this.$message.success('修改成功')
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(error => {
          console.error('请求失败处理', error)
          this.$message.error('修改失败')
        })
    },
    validateForm() {
      const requiredFields = [
        'systemTitle',
        'subSystemTitle',
        'systemSimpleTitle',
        'companyName',
        'logoUrl',
        'imgUrl',
        'defaultCommunityId',
        'ownerTitle',
        'propertyTitle',
        'qqMapKey',
        'mallUrl'
      ]
      
      for (const field of requiredFields) {
        if (!this.editSystemInfoInfo[field]) {
          this.$message.error(`${this.$refs.form.fields.find(f => f.prop === field).label}不能为空`)
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}
</style>